import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.feature-sets.po-pdf-labels-view`

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'PO PDF labels',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'Generate PO PDFs with user-defined custom labels to send to your vendors. Current supported languages are English (latin alphabet characters), Chinese, Spanish, and Thai.',
  },
  createButton: {
    id: `${scope}.createButton`,
    defaultMessage: 'PDF label',
  },
  selectorLabel: {
    id: `${scope}.selectorLabel`,
    defaultMessage: 'PDF labels',
  },
  selectorAriaLabel: {
    id: `${scope}.selectorAriaLabel`,
    defaultMessage: 'PDF label set',
  },
  deleteLabelsButton: {
    id: `${scope}.deleteLabelsButton`,
    defaultMessage: 'Delete labels',
  },
  setAsDefaultButton: {
    id: `${scope}.setAsDefaultButton`,
    defaultMessage: 'Set as default',
  },
  editLabelsButton: {
    id: `${scope}.editLabelsButton`,
    defaultMessage: 'Edit labels',
  },
  createModalTitle: {
    id: `${scope}.createModalTitle`,
    defaultMessage: 'Create label set',
  },
  renameModalTitle: {
    id: `${scope}.renameModalTitle`,
    defaultMessage: 'Edit label set',
  },
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: 'There are no PDF label sets',
  },
  emptyStateContent: {
    id: `${scope}.emptyStateContent`,
    defaultMessage:
      'Create a new label set to customize the labels on your PO PDFs.',
  },
})
